"use client";

import { useState } from "react";
import clsx from "clsx";

import type { StrapiTariffCard } from "@/shared/api/strapi";
import { StarIcon } from "@/shared/icons/StarIcon";
import { TariffCard } from "@/shared/ui/tariff-card/TariffCard";

import styles from "./PricesAndTariffs.module.css";

type TariffsSectionProps = {
  tariffsCards: StrapiTariffCard[];
};

export function TariffsSection({ tariffsCards }: TariffsSectionProps) {
  const [billingCycle, setBillingCycle] = useState<"monthly" | "yearly">(
    "yearly",
  );

  return (
    <>
      <div className={styles.switcher}>
        <button
          type="button"
          onClick={() => setBillingCycle("monthly")}
          className={clsx(
            styles.switcherButton,
            billingCycle === "monthly" && styles.active,
          )}
        >
          Оплата раз в месяц
        </button>
        <button
          type="button"
          onClick={() => setBillingCycle("yearly")}
          className={clsx(
            styles.switcherButton,
            billingCycle === "yearly" && styles.active,
          )}
        >
          <StarIcon size={12} />
          Оплата раз в год
        </button>
      </div>

      <div className={styles.tariffs}>
        {tariffsCards.map((tariff, index) => (
          <TariffCard
            key={`${tariff.title}-${index}`}
            data={tariff}
            index={index + 1}
            billingCycle={billingCycle}
          />
        ))}
      </div>
    </>
  );
}
